import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const ShowOnlyClient = ({ children }) => {
	const [isComponentMounted, setIsComponentMounted] = useState(false);

	useEffect(() => {
		setIsComponentMounted(true);
	}, []);

	const blockCx = cx(styles.block, { [styles.show]: isComponentMounted });

	return <span className={blockCx}>{children}</span>;
};

ShowOnlyClient.propTypes = {
	children: PropTypes.node.isRequired
};

export default ShowOnlyClient;
